<div class="fixed inset-0 z-50 flex items-center justify-center px-4">
  <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="handleCloseModal()"></div>

  <div class="relative w-full max-w-5xl rounded-2xl border border-border-color bg-white shadow-2xl max-h-[90vh] overflow-y-auto">
    <div class="flex items-start justify-between border-b border-border-color px-5 py-4 sticky top-0 bg-white">
      <div>
        <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Editar agenda</p>
        <h1 class="text-xl font-semibold text-dark-color m-0">Atualizar agenda - {{ objectData.name }}</h1>
        <p class="text-sm text-dark-color/70 m-0">Ajuste dias, horários e intervalos desta agenda.</p>
      </div>
      <button class="rounded-lg p-2 text-dark-color/70 hover:bg-light-color/70" (click)="handleCloseModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="p-5">
      <form [formGroup]="formEdit" class="space-y-6" (ngSubmit)="handleSubmit()">
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Nome da agenda</label>
          <input
            type="text"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="name" />
        </div>

        <div class="overflow-x-auto rounded-xl border border-border-color">
          <table class="min-w-full divide-y divide-border-color text-sm">
            <thead class="bg-light-color/60">
              <tr>
                <th class="px-3 py-3 text-left font-semibold text-dark-color">Dia</th>
                <th class="px-3 py-3 text-left font-semibold text-dark-color">Expediente</th>
                <th class="px-3 py-3 text-left font-semibold text-dark-color">Início</th>
                <th class="px-3 py-3 text-left font-semibold text-dark-color">Fim</th>
                <th class="px-3 py-3 text-left font-semibold text-dark-color">Duração</th>
                <th class="px-3 py-3 text-left font-semibold text-dark-color">Intervalo</th>
                <th class="px-3 py-3 text-left font-semibold text-dark-color">Início intervalo</th>
                <th class="px-3 py-3 text-left font-semibold text-dark-color">Fim intervalo</th>
              </tr>
            </thead>
            <tbody formArrayName="configSchedule" class="divide-y divide-border-color">
              <tr
                *ngFor="let config of configsArray.controls; let i = index"
                [formGroupName]="i"
                class="hover:bg-light-color/60 transition">
                <td class="px-3 py-3 text-dark-color">{{ getDayOfWeek(config.value.dayOfWeek) }}</td>
                <td class="px-3 py-3">
                  <input type="checkbox" class="h-4 w-4 accent-primary-color" formControlName="isActive" />
                </td>
                <td class="px-3 py-3">
                  <input type="time" class="rounded-base border border-border-color px-2 py-1 text-sm outline-none focus:border-primary-color" formControlName="startHour" />
                </td>
                <td class="px-3 py-3">
                  <input type="time" class="rounded-base border border-border-color px-2 py-1 text-sm outline-none focus:border-primary-color" formControlName="endHour" />
                </td>
                <td class="px-3 py-3">
                  <input type="time" class="rounded-base border border-border-color px-2 py-1 text-sm outline-none focus:border-primary-color" formControlName="appointmentDuration" />
                </td>
                <td class="px-3 py-3">
                  <input type="checkbox" class="h-4 w-4 accent-primary-color" formControlName="hasBreak" />
                </td>
                <td class="px-3 py-3">
                  <input type="time" class="rounded-base border border-border-color px-2 py-1 text-sm outline-none focus:border-primary-color" formControlName="breakStart" />
                </td>
                <td class="px-3 py-3">
                  <input type="time" class="rounded-base border border-border-color px-2 py-1 text-sm outline-none focus:border-primary-color" formControlName="breakEnd" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="flex justify-end gap-2 pt-2">
          <button type="button" class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="handleCloseModal()">
            Cancelar
          </button>
          <button type="submit" class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
            Salvar alterações
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
